// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/assets/mask-img/testimonial-bg-mask.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.testimonials-section {
  padding: 4rem 0;
  margin: 0 auto;
}
.testimonials-section .testimonials-wrap {
  width: 100%;
  max-width: var(--containerWidth);
  margin: 0 auto;
}
.testimonials-section .testimonials-wrap .testimonials-box {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row-reverse;
  gap: 3rem;
  padding: 0 3.5rem;
}
.testimonials-section .testimonials-wrap .testimonials-box .testimonial-card {
  width: 100%;
  height: 100%;
  background-color: var(--secondaryMain-1000);
  border-radius: 1.5rem;
  padding: 2.25rem;
}
.testimonials-section .testimonials-wrap .testimonials-box .testimonial-card .testimonial-profile-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 0;
  padding-left: 0.75rem;
  position: relative;
}
.testimonials-section .testimonials-wrap .testimonials-box .testimonial-card .testimonial-profile-box .testimonial-bg-img {
  width: 100%;
  max-width: 6.063rem;
  z-index: -1;
  position: absolute;
  top: 0;
  left: 0;
}
.testimonials-section .testimonials-wrap .testimonials-box .testimonial-card .testimonial-profile-box .testimonial-quotes-img {
  width: 100%;
  max-width: 3.125rem;
  margin-bottom: auto;
}
.testimonials-section .testimonials-wrap .testimonials-box .testimonial-card .testimonial-profile-box .profile-img-box {
  width: 100%;
  max-width: 4.313rem;
  background-color: var(--primaryMain-1000);
  aspect-ratio: 138/140;
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  mask-repeat: no-repeat;
  mask-size: 100% 100%;
}
.testimonials-section .testimonials-wrap .testimonials-box .testimonial-card .testimonial-profile-box .profile-img-box img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.testimonials-section .testimonials-wrap .testimonials-box .testimonial-card .testimonial-profile-box .profile-text-box {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  overflow: hidden;
  margin: 0 1rem 0 2rem;
}
.testimonials-section .testimonials-wrap .testimonials-box .testimonial-card .testimonial-profile-box .profile-text-box .name-text {
  color: var(--black-1000);
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.4;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.testimonials-section .testimonials-wrap .testimonials-box .testimonial-card .testimonial-profile-box .profile-text-box .designation-text {
  color: var(--black-1000);
  font-size: 1.25rem;
  font-weight: 500;
  line-height: 1.4;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.testimonials-section .testimonials-wrap .testimonials-box .testimonial-card .text-box {
  margin-top: 2rem;
}
.testimonials-section .testimonials-wrap .testimonials-box .testimonial-card .text-box .para-text {
  color: var(--black-1000);
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 1.4;
}
.testimonials-section .testimonials-wrap .embla {
  --embla-slide-number: calc(100% / 2);
  --embla-slide-gap: 1.5rem;
  width: 100%;
  max-width: 73.25rem;
  border-radius: 1.5rem;
  overflow: hidden;
  filter: drop-shadow(0px 4px 4px var(--black-250));
  -webkit-filter: drop-shadow(0px 4px 4px var(--black-250));
}
.testimonials-section .testimonials-wrap .embla .embla__viewport {
  width: calc(100% + var(--embla-slide-gap) * 2);
  overflow: hidden;
  margin-left: calc(var(--embla-slide-gap) - var(--embla-slide-gap) - var(--embla-slide-gap));
}
.testimonials-section .testimonials-wrap .embla .embla__viewport .embla__container {
  display: flex;
}
.testimonials-section .testimonials-wrap .embla .embla__viewport .embla__container .embla__slide {
  min-width: 0;
  flex: 0 0 var(--embla-slide-number);
  padding: 0 var(--embla-slide-gap);
}
@media screen and (max-width: 991.98px) {
  .testimonials-section {
    padding: 2.5rem 0;
  }
  .testimonials-section .testimonials-wrap .testimonials-box {
    flex-direction: column;
    gap: 2rem;
    padding: 0 1.25rem;
  }
  .testimonials-section .testimonials-wrap .testimonials-box .testimonial-card {
    border-radius: 1rem;
    padding: 1.25rem;
  }
  .testimonials-section .testimonials-wrap .testimonials-box .testimonial-card .testimonial-profile-box {
    padding-left: 0.5rem;
  }
  .testimonials-section .testimonials-wrap .testimonials-box .testimonial-card .testimonial-profile-box .testimonial-bg-img {
    max-width: 4rem;
  }
  .testimonials-section .testimonials-wrap .testimonials-box .testimonial-card .testimonial-profile-box .testimonial-quotes-img {
    max-width: 1.5rem;
  }
  .testimonials-section .testimonials-wrap .testimonials-box .testimonial-card .testimonial-profile-box .profile-img-box {
    max-width: 2.75rem;
  }
  .testimonials-section .testimonials-wrap .testimonials-box .testimonial-card .testimonial-profile-box .profile-text-box {
    gap: 0.25rem;
    margin: 0 0.5rem 0 1rem;
  }
  .testimonials-section .testimonials-wrap .testimonials-box .testimonial-card .testimonial-profile-box .profile-text-box .name-text {
    font-size: 1rem;
  }
  .testimonials-section .testimonials-wrap .testimonials-box .testimonial-card .testimonial-profile-box .profile-text-box .designation-text {
    font-size: 0.875rem;
  }
  .testimonials-section .testimonials-wrap .testimonials-box .testimonial-card .text-box {
    margin-top: 1rem;
  }
  .testimonials-section .testimonials-wrap .testimonials-box .testimonial-card .text-box .para-text {
    font-size: 1rem;
  }
  .testimonials-section .testimonials-wrap .embla {
    --embla-slide-number: calc(100% / 2);
    --embla-slide-gap: 0.625rem;
    border-radius: 1rem;
  }
}
@media screen and (max-width: 767.98px) {
  .testimonials-section {
    padding: 2rem 0;
  }
  .testimonials-section .testimonials-wrap .testimonials-box {
    flex-direction: column;
    gap: 1.5rem;
    padding: 0 1rem;
  }
  .testimonials-section .testimonials-wrap .testimonials-box .testimonial-card {
    padding: 1rem;
  }
  .testimonials-section .testimonials-wrap .testimonials-box .testimonial-card .testimonial-profile-box .profile-text-box .name-text {
    font-size: 0.875rem;
  }
  .testimonials-section .testimonials-wrap .testimonials-box .testimonial-card .testimonial-profile-box .profile-text-box .designation-text {
    font-size: 0.75rem;
  }
  .testimonials-section .testimonials-wrap .testimonials-box .testimonial-card .text-box {
    margin-top: 0.75rem;
  }
  .testimonials-section .testimonials-wrap .testimonials-box .testimonial-card .text-box .para-text {
    font-size: 0.875rem;
  }
  .testimonials-section .testimonials-wrap .embla {
    --embla-slide-number: calc(100% / 2);
    --embla-slide-gap: 0.25rem;
    border-radius: 1rem;
  }
}
@media screen and (max-width: 639.98px) {
  .testimonials-section {
    padding: 2rem 0;
  }
  .testimonials-section .testimonials-wrap .embla {
    --embla-slide-number: calc(100% / 1);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/TestimonialsSection/TestimonialsStyle.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,cAAA;AACF;AACE;EACE,WAAA;EACA,gCAAA;EACA,cAAA;AACJ;AACI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,2BAAA;EACA,SAAA;EACA,iBAAA;AACN;AACM;EACE,WAAA;EACA,YAAA;EACA,2CAAA;EACA,qBAAA;EACA,gBAAA;AACR;AACQ;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,UAAA;EACA,qBAAA;EACA,kBAAA;AACV;AACU;EACE,WAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AACZ;AAEU;EACE,WAAA;EACA,mBAAA;EACA,mBAAA;AAAZ;AAGU;EACE,WAAA;EACA,mBAAA;EACA,yCAAA;EACA,qBAAA;EACA,mDAAA;EACA,sBAAA;EACA,oBAAA;AADZ;AAGY;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;AADd;AAKU;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;AAHZ;AAKY;EACE,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAHd;AAMY;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAJd;AASQ;EACE,gBAAA;AAPV;AASU;EACE,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AAPZ;AAaI;EACE,oCAAA;EACA,yBAAA;EACA,WAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,iDAAA;EACA,yDAAA;AAXN;AAaM;EACE,8CAAA;EACA,gBAAA;EACA,2FAAA;AAXR;AAaQ;EACE,aAAA;AAXV;AAaU;EACE,YAAA;EACA,mCAAA;EACA,iCAAA;AAXZ;AAkBE;EAvIF;IAwII,iBAAA;EAfF;EAkBI;IACE,sBAAA;IACA,SAAA;IACA,kBAAA;EAhBN;EAkBM;IACE,mBAAA;IACA,gBAAA;EAhBR;EAkBQ;IACE,oBAAA;EAhBV;EAkBU;IACE,eAAA;EAhBZ;EAmBU;IACE,iBAAA;EAjBZ;EAoBU;IACE,kBAAA;EAlBZ;EAqBU;IACE,YAAA;IACA,uBAAA;EAnBZ;EAqBY;IACE,eAAA;EAnBd;EAsBY;IACE,mBAAA;EApBd;EAyBQ;IACE,gBAAA;EAvBV;EAyBU;IACE,eAAA;EAvBZ;EA6BI;IACE,oCAAA;IACA,2BAAA;IACA,mBAAA;EA3BN;AACF;AA+BE;EAnMF;IAoMI,eAAA;EA5BF;EA+BI;IACE,sBAAA;IACA,WAAA;IACA,eAAA;EA7BN;EA+BM;IACE,aAAA;EA7BR;EAiCY;IACE,mBAAA;EA/Bd;EAkCY;IACE,kBAAA;EAhCd;EAqCQ;IACE,mBAAA;EAnCV;EAqCU;IACE,mBAAA;EAnCZ;EAyCI;IACE,oCAAA;IACA,0BAAA;IACA,mBAAA;EAvCN;AACF;AA2CE;EA7OF;IA8OI,eAAA;EAxCF;EA4CI;IACE,oCAAA;EA1CN;AACF","sourcesContent":[".testimonials-section {\n  padding: 4rem 0;\n  margin: 0 auto;\n\n  .testimonials-wrap {\n    width: 100%;\n    max-width: var(--containerWidth);\n    margin: 0 auto;\n\n    .testimonials-box {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      flex-direction: row-reverse;\n      gap: 3rem;\n      padding: 0 3.5rem;\n\n      .testimonial-card {\n        width: 100%;\n        height: 100%;\n        background-color: var(--secondaryMain-1000);\n        border-radius: 1.5rem;\n        padding: 2.25rem;\n\n        .testimonial-profile-box {\n          display: flex;\n          justify-content: space-between;\n          align-items: center;\n          z-index: 0;\n          padding-left: 0.75rem;\n          position: relative;\n          \n          .testimonial-bg-img {\n            width: 100%;\n            max-width: 6.063rem;\n            z-index: -1;\n            position: absolute;\n            top: 0;\n            left: 0;\n          }\n          \n          .testimonial-quotes-img {\n            width: 100%;\n            max-width: 3.125rem;\n            margin-bottom: auto;\n          }\n\n          .profile-img-box {\n            width: 100%;\n            max-width: 4.313rem;\n            background-color: var(--primaryMain-1000);\n            aspect-ratio: 138/140;\n            mask-image: url(\"../../../public/assets/mask-img/testimonial-bg-mask.svg\");\n            mask-repeat: no-repeat;\n            mask-size: 100% 100%;\n            \n            img {\n              width: 100%;\n              height: 100%;\n              object-fit: cover;\n              object-position: center;\n            }\n          }\n\n          .profile-text-box {\n            width: 100%;\n            display: flex;\n            flex-direction: column;\n            gap: 0.25rem;\n            overflow: hidden;\n            margin: 0 1rem 0 2rem;\n\n            .name-text {\n              color: var(--black-1000);\n              font-size: 1.5rem;\n              font-weight: 700;\n              line-height: 1.4;\n              white-space: nowrap;\n              text-overflow: ellipsis;\n              overflow: hidden;\n            }\n\n            .designation-text {\n              color: var(--black-1000);\n              font-size: 1.25rem;\n              font-weight: 500;\n              line-height: 1.4;\n              white-space: nowrap;\n              text-overflow: ellipsis;\n              overflow: hidden;\n            }\n          }\n        }\n\n        .text-box {\n          margin-top: 2rem;\n\n          .para-text {\n            color: var(--black-1000);\n            font-size: 1.5rem;\n            font-weight: 400;\n            line-height: 1.4;\n          }\n        }\n      }      \n    }\n\n    .embla {\n      --embla-slide-number: calc(100% / 2);\n      --embla-slide-gap: 1.5rem;\n      width: 100%;\n      max-width: 73.25rem;\n      border-radius: 1.5rem;\n      overflow: hidden;\n      filter: drop-shadow(0px 4px 4px var(--black-250));\n      -webkit-filter: drop-shadow(0px 4px 4px var(--black-250));\n      \n      .embla__viewport {\n        width: calc(100% + calc(var(--embla-slide-gap) * 2));\n        overflow: hidden;\n        margin-left: calc(var(--embla-slide-gap) - var(--embla-slide-gap) - var(--embla-slide-gap));\n    \n        .embla__container {\n          display: flex;\n          \n          .embla__slide {\n            min-width: 0;\n            flex: 0 0 var(--embla-slide-number);\n            padding: 0 var(--embla-slide-gap);\n          }\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 991.98px) {\n    padding: 2.5rem 0;\n\n    .testimonials-wrap {  \n      .testimonials-box {\n        flex-direction: column;\n        gap: 2rem;\n        padding: 0 1.25rem;\n  \n        .testimonial-card {\n          border-radius: 1rem;\n          padding: 1.25rem;\n  \n          .testimonial-profile-box {  \n            padding-left: 0.5rem;\n\n            .testimonial-bg-img {\n              max-width: 4rem;\n            }\n            \n            .testimonial-quotes-img {\n              max-width: 1.5rem;\n            }\n  \n            .profile-img-box {\n              max-width: 2.75rem;\n            }\n  \n            .profile-text-box {\n              gap: 0.25rem;\n              margin: 0 0.5rem 0 1rem;\n  \n              .name-text {\n                font-size: 1rem;\n              }\n  \n              .designation-text {\n                font-size: 0.875rem;\n              }\n            }\n          }\n  \n          .text-box {\n            margin-top: 1rem;\n  \n            .para-text {\n              font-size: 1rem;\n            }\n          }\n        }      \n      }\n  \n      .embla {\n        --embla-slide-number: calc(100% / 2);\n        --embla-slide-gap: 0.625rem;\n        border-radius: 1rem;\n      }\n    }\n  }\n\n  @media screen and (max-width: 767.98px) {\n    padding: 2rem 0;\n\n    .testimonials-wrap {  \n      .testimonials-box {\n        flex-direction: column;\n        gap: 1.5rem;\n        padding: 0 1rem;\n  \n        .testimonial-card {\n          padding: 1rem;\n  \n          .testimonial-profile-box {  \n            .profile-text-box {  \n              .name-text {\n                font-size: 0.875rem;\n              }\n  \n              .designation-text {\n                font-size: 0.75rem;\n              }\n            }\n          }\n  \n          .text-box {\n            margin-top: 0.75rem;\n  \n            .para-text {\n              font-size: 0.875rem;\n            }\n          }\n        }      \n      }\n  \n      .embla {\n        --embla-slide-number: calc(100% / 2);\n        --embla-slide-gap: 0.25rem;\n        border-radius: 1rem;\n      }\n    }\n  }\n\n  @media screen and (max-width: 639.98px) {\n    padding: 2rem 0;\n\n    .testimonials-wrap {\n  \n      .embla {\n        --embla-slide-number: calc(100% / 1);\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
